<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-07-30 10:35:06
 * @LastEditors: 刘小二
 * @LastEditTime: 2025-06-27 08:59:01
 * @Description: 成本结转表-生成审批单
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/Wise/docking/accountingSheet/report/approvalForm.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="dialog" width="1140px" :close-on-click-modal="false" :before-close="resetForm">
      <span slot="title" class="dialog-title">生成审批单</span>
      <div>
        <el-form ref="form" :rules="rules" :model="formVal" label-width="150px" :inline="true" label-position="right">
          <el-form-item label-width="80px" prop="submitUserName">
            <span slot="label">申请人</span>
            <span v-if="!formVal.submitUserName" style="color: forestgreen;width: 250px;"
              @click="openAccount">请选择申请人</span>
            <span v-else style="color: forestgreen;" @click="openAccount">
              <el-input v-model="formVal.submitUserName" style="color: forestgreen;width: 250px;"></el-input>
            </span>
          </el-form-item>
          <div>
            <el-form-item label-width="80px" prop="sharedProductName">
              <span slot="label">项目</span>
              <span v-if="!formVal.sharedProductName" style="color: forestgreen;width: 250px;"
                @click="openProject">请选择项目</span>
              <span v-else style="color: forestgreen;" @click="openProject">
                <el-input v-model="formVal.sharedProductName" style="color: forestgreen;width: 250px;"></el-input>
              </span>
            </el-form-item>
            <el-form-item prop="paperAttachments">
              <span slot="label">纸质附件</span>
              <el-select ref="selection" v-model="formVal.paperAttachments" style="width: 200px">
                <el-option :key="0" label="无" :value="0"></el-option>
                <el-option :key="1" label="有" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe show-overflow-tooltip style="width: 100%"
          :data="tableData" tooltip-effect="dark" :span-method="arraySpanMethod">
          <template v-for="(item, index) in table">
            <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
              align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="item.label == '业务大类'">
                  <el-select v-model="scope.row.businessType" placeholder="请选择" filterable clearable style="width:100%">
                    <el-option v-for="item in businessBigTypeList" :key="item.operationTypeCode"
                      :label="item.operationTypeName" :value="item.operationTypeName"
                      @click.native="setSmallName(item, scope.$index)"></el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '业务类型'">
                  <el-select v-model="scope.row.businessSmallType" placeholder="请选择" filterable clearable
                    style="width:100%">
                    <el-option v-for="item in businessTypeList[scope.row.dataType * 1 - 1]"
                      :key="item.operationSubTypeCode" :label="item.operationSubTypeName"
                      :value="item.operationSubTypeName" @click.native="setBusinessName(item, scope.$index)"></el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '费用分摊部门'">
                  <el-link v-if="!scope.row.costShareDepartment" :underline="false" type="success"
                    @click="openDepDetail(scope.$index)">请选择</el-link>
                  <el-link v-else :underline="false" type="success" @click="openDepDetail(scope.$index)">{{
                    scope.row.costShareDepartment }}</el-link>
                </span>
                <span v-else-if="item.label == '明细供应商'">
                  <el-link v-if="!scope.row.mainSupplierName" :underline="false" type="success"
                    @click="openSupplyDetail(scope.$index)">请选择</el-link>
                  <el-link v-else :underline="false" type="success" @click="openSupplyDetail(scope.$index)">{{
                    scope.row.mainSupplierName }}</el-link>
                </span>
                <span v-else-if="item.label == '分摊金额'">
                  <el-input v-model="scope.row.sharedAmount" style="width:100%" placeholder="请输入"
                    @change="changeMoney(scope.$index)"></el-input>
                </span>
                <!-- <span v-else-if="item.label == '总金额'">
                  <el-input v-model="scope.row.money" style="width:100%" placeholder="请输入总金额"
                    @change="changeMoney(scope.$index)"></el-input>
                </span> -->
                <span v-else-if="item.label == '事由'">
                  <el-input v-model="scope.row.resion" style="width:100%" placeholder="请输入事由"
                    @change="changeResion(scope.$index)"></el-input>
                </span>
                <span v-else-if="item.label == '附件'">
                  <el-button class="bottom_one" size="mini" @click="upFile(scope.$index)">上传附件</el-button>
                </span>
                <span v-else-if="item.label == '共享状态'">
                  <span v-if="scope.row.shareStatus == 1">提交共享成功</span>
                  <span v-if="scope.row.shareStatus == 2">提交共享失败</span>
                  <span v-if="scope.row.shareStatus == 3">共享审核完成</span>
                  <span v-if="scope.row.shareStatus == 4">共享审核驳回</span>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetForm">关 闭</el-button>
        <el-button class="bottom_all" :disabled="isSave" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 上传附件 -->
    <el-dialog v-dialogDrag :visible.sync="uploadFileDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">上传附件</span>
      <div v-loading="loading" element-loading-text="上传中..." element-loading-background="rgba(0, 0, 0, 0.8)"
        class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag
          action="/resource/resources/upload" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
          <div slot="tip" class="el-upload__tip" style="color:red">*{{ upload_tip }}</div>
        </el-upload>
        <div style="margin:10px;font-size:18px">
          <div style="text-align: left;">
            已上传文件:
            <div v-for="(item, index) in tableData[lowindex].files" :key="index">
              <el-link type="sucess" :underline="false" @click="lookFile(item.url)">{{
                item.name }}</el-link> <el-link type="danger" style="margin-left: 24px;" :underline="false"
                @click="deleteFile(index)">删除</el-link>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="uploadFileDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 核算主体 -->
    <AccountTable ref="accountTable" :dialog.sync="accountDialog" @resetAccount="resetAccount" @setAccount="setAccount" />
    <!-- 项目 -->
    <ProjectTable ref="projectTable" :dialog.sync="projectDia" @resetProject="resetProject" @setProject="setProject" />
    <!-- 费用分摊部门 -->
    <DepTable ref="DepTable" :dialog.sync="depDia" @resetDep="resetDep" @setDep="setDep" />
    <!-- 明细客商 -->
    <detailSupply ref="detailSupply" :dialog.sync="detailSupplyDialog" :centerRow="tableData[lowindex]"
      @reset="resetSupply" @setDetail="setDetail" />
    <!-- 供应商台账数据截图 -->
    <div style="position: fixed; top: -10000px;left:-10000px;overflow:hidden;">
      <supplierTableImg id="supplierTable" ref="supplierTable" :key="`supplierTable`" :tableData="supplierTableImgData"
        :dataType="supplierTableImgType" />
    </div>

  </div>
</template>
<script>
import { cardLogin_HX, getUserList_HX, getProject_HX, updateGXCostState } from "@/views/ShareSystem/api/mainHx.js";
import AccountTable from "./accountTable.vue";
import ProjectTable from "./ProjectTable.vue";
import DepTable from "./DepTable.vue";
import detailSupply from "./supplierTable.vue";
import supplierTableImg from "./supplierTableImg.vue";
import { getBusinessSingle } from "@/api/docking.js";
import { UPLOAD_TIP } from "@/utils/utils";
import { getToken } from "@/utils/auth";
import html2canvas from 'html2canvas';
import { uploadFile } from "@/api/common.js";
import {
  saveBusinessSingle,
  querySupplier
} from "@/api/docking.js";
import {
  getCategory
} from "@/views/ShareSystem/api/mainHx.js";
import { _debounce } from '@/utils/utils.js'
// import { alterContractProfitCenter, } from "@/api/contractManageApi";
export default {
  components: {
    AccountTable,
    ProjectTable,
    DepTable,
    detailSupply,
    supplierTableImg
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    params: {},
  },
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
        status: 1,//只查询启用状态
      },
      accessToken: "",
      total: 0,
      // userData: [],
      projectHxList: [],
      businessBigList: [
        { id: "HSYW227", name: "库存商品出库" },
      ],
      businessSmallList: [
        { id: "HSYW227001", name: "自制库存商品-结转主营业务成本" },
        { id: "HSYW227002", name: "外购库存商品结转主营业务成本" },
      ],
      rules: {
        submitUserName: [{ required: true, message: "请选择事由", trigger: "change" }],
        sharedProductName: [{ required: true, message: "请选择事由", trigger: "change" }],
        paperAttachments: [{ required: true, message: "请选择事由", trigger: "change" }],
      },
      accountDialog: false, //核算主体
      projectDia: false,//项目
      depDia: false,//分摊部门
      formVal: {
        // accountMainBody:"",
        mainBodyId: "",
        mainBodyName: "",
        businessTime: "",
        paperAttachments: 0,
        submitUserName: "",
        sharedProductCode: "",
        sharedProductName: "",
      },
      detailSupplyDialog: false,//明细客商
      detailRow: {},
      saveType: "2",
      tableData: [
        {
          files: [],
        },
        {
          files: [],
        },
        {
          files: [],
        }
      ],
      oldAmount: 0,
      table: [
        { label: "业务大类", width: "150", prop: "operationSubTypeName", status: true },
        { label: "业务类型", width: "150", prop: "operationSubTypeName", status: true },
        { label: "费用分摊部门", width: "120", prop: "costShareDepartment", status: true },
        { label: "明细供应商", width: "120", prop: "detailSupply", status: true },
        { label: "分摊金额", width: "auto", prop: "sharedAmount", status: true },
        { label: "总金额", width: "auto", prop: "money", status: true },
        { label: "事由", width: "120", prop: "resion", status: true },
        { label: "附件", width: "80", prop: "", status: true },
        { label: "共享状态", width: "120", prop: "", status: true },
      ],
      businessTypeList: [[], [], []],
      lowindex: 0,
      fileArr: [],
      uploadFileDig: false,
      upload_tip: UPLOAD_TIP,
      upheader: {},
      loading: false,
      oldTableData: [],
      supplierTableImgData: [],
      supplierTableImgType: 1,
      isSave: false,
    }
  },
  watch: {

  },
  created() {
    this.upheader = {
      "access-token": getToken(),
    };
  },
  methods: {
    deleteFile(index) {
      this.tableData[this.lowindex].files.splice(index, 1);
      this.tableData.forEach(item => {
        if (item.dataType == this.tableData[this.lowindex].dataType) {
          item.files = this.tableData[this.lowindex].files
        }
      });
    },
    lookFile(imgUrl) {
      window.open(imgUrl, "_blank");
    },
    filebefore(file) {
      this.loading = true;
      const allowedFormats = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png',];
      const isAllowedFormat = allowedFormats.includes(file.type);
      if (!isAllowedFormat) {
        this.$message.error("数据上传必须是  pdf, jpeg, jpg, png,格式!");
        this.loading = false;
      }
      return isAllowedFormat;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code === 1001) {
        this.tableData[this.lowindex].files.push({
          name: res.data.fileName,
          url: 'https://lvshe.huashijc.com/file/' + res.data.fileUrl
        })
        this.tableData.forEach(item => {
          if (item.dataType == this.tableData[this.lowindex].dataType) {
            item.files = this.tableData[this.lowindex].files
          }
        });
      }
    },
    upFile(index) {
      console.log(this.tableData)
      this.lowindex = index
      this.uploadFileDig = true
    },
    changeFileName() {
      this.tableData.forEach(item => {
        item.files[0].name = item.businessSmallType
      })
    },
    async initData() {
      console.log("this.params----------------------------------")
      console.log(this.params)
      this.formVal.mainBodyId = this.params.mianBodyId
      this.formVal.mainBodyName = this.params.mianBody
      this.formVal.businessTime = this.params.businessTime
      let that = this
      let res = await cardLogin_HX({ idCard: "icps" })
      if (res.code == 1001) {
        let info = res.data;
        if (info && info.accessToken) {
          that.accessToken = info.accessToken
          // this.getUserList(that.accessToken);
          // this.getProject_HX(that.accessToken);
          this.getBusinessSingle(that.params);
          this.getCategory();
        }
      }
    },
    restParams() {
      this.tableParams = {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
      }
      this.initData();
    },
    resetSupply() {
      this.detailSupplyDialog = false
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // let num = 0
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          const values = data.map(item => Number(item["totalAmount"]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = '';
          }
        }
        if (index === 3) {
          sums[index] = this.oldAmount;
          return;
        }
      });
      return sums;
    },
    setBusinessName(data, index) {
      this.tableData[index].operationSubTypeId = data.operationSubTypeCode
    },
    setName(data) {
      this.formVal.employeeCode = data.code
      this.$refs.accountTable.setNcNo(data);
    },
    changeResion(index) {
      this.tableData.forEach(item => {
        if (item.dataType == this.tableData[index].dataType) {
          item.resion = this.tableData[index].resion
        }
      });
    },
    changeMoney(index) {
      //根据dataType 计算总金额
      let typeObj = this.tableData.filter(data => data.dataType === this.tableData[index].dataType);
      const totalSharedAmount = typeObj.reduce((sum, item) => {
        // 确保 sharedAmount 是数字，避免异常
        const amount = Number(item.sharedAmount) || 0;
        return this.decimal.add(Number(sum), Number(amount));
      }, 0);
      this.tableData.forEach(item => {
        if (item.dataType == this.tableData[index].dataType) {
          item.money = totalSharedAmount
        }
      });
    },
    setSmallName(data, index) {
      this.tableData.forEach(item => {
        if (item.dataType == this.tableData[index].dataType) {
          item.operationTypeCode = data.id
          item.businessType = data.operationTypeName
        }
      });
      this.getCategory(data.operationTypeName, index)
    },
    setDetail(param) {
      console.log(param)
      this.$set(this.tableData[this.lowindex], 'supplierId', param.supplyId);
      this.$set(this.tableData[this.lowindex], 'supplierName', param.supplyName);
      this.$set(this.tableData[this.lowindex], 'mainSupplierCode', param.detailSupplyCode);
      this.$set(this.tableData[this.lowindex], 'mainSupplierName', param.detailSupplyName);
      this.$set(this.tableData[this.lowindex], 'supplierLedgerId', param.id);
      console.log(this.tableData)
      this.resetSupply();
    },
    setAccount(row) {
      // this.formVal.accountMainBody = row.deptName
      this.formVal.submitUserName = row.deptName
      this.formVal.deptName = row.deptName
      this.formVal.leCode = row.deptCode
      this.formVal.employeeCode = row.foreignId
      this.formVal.postId = row.positionCode
    },
    setProject(row) {
      // this.formVal.accountMainBody = row.deptName
      this.formVal.sharedProductCode = row.code
      this.formVal.sharedProductName = row.name
    },
    setDep(param) {
      console.log(param)
      this.tableData[this.lowindex].costShareDepartment = param.name
      this.tableData[this.lowindex].costShareDepartmentCode = param.code
      this.resetDep();
    },
    openSupplyDetail(index) {
      this.lowindex = index
      this.detailSupplyDialog = true
    },
    openDepDetail(index) {
      this.lowindex = index
      this.depDia = true
    },
    getProject_HX(accessToken) {
      if (!accessToken) {
        this.$message.error('accessToken获取为空～')
        return;
      } else {
        getProject_HX({ page: 1, pageSize: 100 }, accessToken).then((res) => {
          this.projectHxList = res.data?.data;
        });
      }
    },
    getUserList(accessToken) {
      getUserList_HX(accessToken).then((res) => {
        this.userData = res.data;
        console.log(this.userData)
      });
    },
    getCategory(operationTypeName, index) {
      let param = {
        page: 1,
        pageSize: 9999,
        operationTypeName: operationTypeName,
      }
      getCategory(param, this.accessToken).then(res => {
        if (res.code == 1001) {
          if (index || index == 0) {
            this.$set(this.businessTypeList, index, res.data.records[0].mainDictGxBusinessList);
          } else {
            this.businessBigTypeList = res.data.records;
          }

        }
      });
    },
    setCommonFields(obj, item, data) {
      obj.businessType = item.businessType;
      obj.code = item.code;
      obj.dataType = item.dataType;
      obj.money = item.money;
      obj.amountShares = item.amountShares;
      obj.shareStatus = item.shareStatus;
      obj.businessTime = this.formVal.businessTime;
      obj.files = []

      // 根据 dataType 设置字段
      if (item.dataType === 1) {
        obj.businessType = '原材料出库';
        obj.operationTypeCode = 'HSYW142';
        obj.businessSmallType = '生产成本_材料费';
        obj.operationSubTypeId = 'HSYW142051';
        obj.resion = this.formVal.businessTime + '原材料耗用';
      } else if (item.dataType === 2) {
        obj.businessType = '原材料出库';
        obj.operationTypeCode = 'HSYW142';
        obj.businessSmallType = '委托加工出库';
        obj.operationSubTypeId = 'HSYW142012';
        obj.resion = this.formVal.businessTime + '委托材料出库';
      } else if (item.dataType === 3) {
        obj.businessType = '委托加工物资验收入库';
        obj.operationTypeCode = 'HSYW229';
        obj.businessSmallType = '库存商品入库';
        obj.operationSubTypeId = 'HSYW229001';
        obj.resion = this.formVal.businessTime + '委托材料耗用';
      }

      // 根据 mianBodyId 设置建材主体相关字段
      switch (data.mianBodyId) {
        case '22876753760489472':
          obj.costShareDepartment = '跳蹬河搅拌站';
          obj.costShareDepartmentCode = 'HB0202012';
          this.formVal.sharedProductCode = 'HG0202-20220831001';
          this.formVal.sharedProductName = '四川华西绿舍建材有限公司混凝土事业部分部';
          break;
        case '112740030409216000':
          obj.costShareDepartment = '崇州搅拌站';
          obj.costShareDepartmentCode = 'HB0212001';
          this.formVal.sharedProductCode = 'HG0212-20220831001';
          this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司本部';
          break;
        case '360866214131666944':
          obj.costShareDepartment = '安全营运部';
          obj.costShareDepartmentCode = 'HB021202003';
          this.formVal.sharedProductCode = 'HG02120201-20231130001';
          this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司金牛分公司分部';
          break;
        case '361334596329148416':
          obj.costShareDepartment = '崇州搅拌站';
          obj.costShareDepartmentCode = 'HB0202018';
          break;
        case '361334653501706240':
          obj.costShareDepartment = '安全营运部';
          obj.costShareDepartmentCode = 'HB021201003';
          this.formVal.sharedProductCode = 'HG02120101-20231130001';
          this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司武侯分公司分部';
          break;
        default:
          obj.costShareDepartment = '';
          obj.costShareDepartmentCode = '';
      }
      return obj
    },
    getBusinessSingle(data) {
      let params = {
        businessTime: data.businessTime,
        mainBodyId: data.mianBodyId,
      }
      this.oldAmount = 0
      getBusinessSingle(params).then((res) => {
        if (res.code == 1001) {
          this.$emit('openDialog')
          if (res?.data?.length > 0) {
            this.oldTableData = res.data
            //设置默认值


            let newTableData = []
            res.data.forEach((item, index) => {
              if (item.supplierList && item.supplierList.length > 0) {
                item.supplierList.forEach(supplier => {
                  // 这里用浅拷贝，避免修改原数据
                  let obj = { ...supplier };
                  obj = this.setCommonFields(obj, item, data);
                  newTableData.push(obj);
                });
              } else {
                // supplierList 为空时，构造默认对象
                let obj = {
                  page: "",
                  pageSize: "",
                  sortProperty: "",
                  sortType: "",
                  startData: "",
                  endData: "",
                  id: "",
                  detailId: "",
                  supplierLedgerId: "",
                  supplierId: "",
                  supplierName: "",
                  mainSupplierCode: "",
                  mainSupplierName: "",
                  costShareDepartment: "",
                  costShareDepartmentCode: "",
                  businessSmallType: "",
                  sharedAmount: "",
                };
                obj = this.setCommonFields(obj, item, data);
                newTableData.push(obj);
              }
              this.getCategory(item.businessType, index)
            });
            this.$set(this, 'tableData', newTableData)
          }
          // res.data.forEach((item, index) => {

          //   //附件赋值
          //   if (item.dataType == 1) {
          //     item['files'] = [{ name: '原材料耗用', url: data.file1 }]
          //     item.businessType == '原材料出库'
          //     item.operationTypeCode = 'HSYW142'
          //     item.businessSmallType = '生产成本_材料费'
          //     item['operationSubTypeId'] = 'HSYW142051'
          //     item.resion = this.formVal.businessTime + '原材料耗用' //事由默认值
          //   }
          //   if (item.dataType == 2) {

          //     item.businessType == '原材料出库'
          //     item.operationTypeCode = 'HSYW142'
          //     item.businessSmallType = '委托加工出库'
          //     item['operationSubTypeId'] = 'HSYW142012'
          //     item['files'] = [{ name: '委托材料出库', url: data.file2 }]
          //     item.resion = this.formVal.businessTime + '委托材料出库' //事由默认值
          //   }
          //   if (item.dataType == 3) {

          //     item.businessType == '委托加工物资验收入库'
          //     item.operationTypeCode = 'HSYW229'
          //     item.businessSmallType = '库存商品入库'
          //     item['operationSubTypeId'] = 'HSYW229001'
          //     item['files'] = [{ name: '委托材料耗用', url: data.file2 }]
          //     item.resion = this.formVal.businessTime + '委托材料耗用' //事由默认值
          //   }
          //   //获取业务类型
          //   this.getCategory(item.businessType, index)
          //   //建材主体
          //   if (data.mianBodyId == '22876753760489472') {
          //     if (index == 0) {
          //       item.detailSupply = '外部单位'
          //       item.venderCode = 'HS061084531'
          //     } else {
          //       item.detailSupply = '四川华西绿舍混凝土工程有限公司本部'
          //       item.venderCode = 'HG0212'
          //     }
          //     item.costShareDepartment = '跳蹬河搅拌站'
          //     item.costShareDepartmentCode = 'HB0202012'
          //     this.formVal.sharedProductCode = 'HG0202-20220831001'
          //     this.formVal.sharedProductName = '四川华西绿舍建材有限公司混凝土事业部分部'
          //   } else if (data.mianBodyId == '112740030409216000') { //混凝土工程有限公司
          //     if (index == 0) {
          //       item.detailSupply = '外部单位'
          //       item.venderCode = 'HS061084531'
          //     } else {
          //       item.detailSupply = '四川华西绿舍建材有限公司混凝土事业部分部'
          //       item.venderCode = 'HG0202'
          //     }
          //     item.costShareDepartment = '崇州搅拌站'
          //     item.costShareDepartmentCode = 'HB0212001'
          //     this.formVal.sharedProductCode = 'HG0212-20220831001'
          //     this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司本部'
          //   } else if (data.mianBodyId == '360866214131666944') { //金牛
          //     if (index == 0) {
          //       item.detailSupply = '外部单位'
          //       item.venderCode = 'HS061084531'
          //     } else {
          //       item.detailSupply = '四川华西绿舍建材有限公司混凝土事业部分部'
          //       item.venderCode = 'HG0202'
          //     }
          //     item.costShareDepartment = '安全营运部'
          //     item.costShareDepartmentCode = 'HB021202003'
          //     this.formVal.sharedProductCode = 'HG02120201-20231130001'
          //     this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司金牛分公司分部'
          //   } else if (data.mianBodyId == '361334596329148416') { //青白江
          //     if (index == 0) {
          //       item.detailSupply = '外部单位'
          //       item.venderCode = 'HS061084531'
          //     } else {
          //       item.detailSupply = ''
          //       item.venderCode = ''
          //     }
          //     item.costShareDepartment = '崇州搅拌站'
          //     item.costShareDepartmentCode = 'HB0202018'
          //   } else if (data.mianBodyId == '361334653501706240') { //武侯
          //     if (index == 0) {
          //       item.detailSupply = '外部单位'
          //       item.venderCode = 'HS061084531'
          //     } else {
          //       item.detailSupply = '四川华西绿舍建材有限公司混凝土事业部分部'
          //       item.venderCode = 'HG0202'
          //     }
          //     item.costShareDepartment = '安全营运部'
          //     item.costShareDepartmentCode = 'HB021201003'
          //     this.formVal.sharedProductCode = 'HG02120101-20231130001'
          //     this.formVal.sharedProductName = '四川华西绿舍混凝土工程有限公司武侯分公司分部'
          //   }


          //   else {
          //     item.detailSupply = ''
          //     item.costShareDepartment = ''
          //   }
          // })
          // this.$set(this, 'tableData', res.data)

        } else {
          this.$emit("mainLoadingClose");
        }
      }).catch(() => {
        this.$emit("mainLoadingClose");
      });
    },
    openAccount() {
      this.accountDialog = true
      this.$refs.accountTable.initData();
    },
    resetAccount() {
      this.accountDialog = false
    },
    openProject() {
      this.projectDia = true
    },
    resetProject() {
      this.projectDia = false
    },
    resetDep() {
      this.depDia = false
    },

    resetForm() {
      this.formVal = this.$options.data().formVal
      this.$emit("resetForm");
    },
    //月报量-保存
    submitForm: _debounce(function () {
      if (!this.formVal.submitUserName) {
        this.$message.warning('请选择申请人!')
        return
      }
      if (!this.formVal.sharedProductName) {
        this.$message.warning('请选择项目!')
        return
      }
      if (!this.formVal.paperAttachments && this.formVal.paperAttachments != 0) {
        this.$message.warning('请选择纸质附件!')
        return
      }
      // let tableData = JSON.parse(JSON.stringify(this.tableData))
      // console.log(tableData)
      let tableDataMust = false
      // let sharedAmountOver = false
      this.tableData.forEach(item => {
        if ((!item.operationTypeCode || !item.operationSubTypeId || !item.costShareDepartmentCode || !item.mainSupplierCode || !item.resion) && item.money != 0) {
          tableDataMust = true
        }
        if (item.sharedAmount === null || item.sharedAmount === '' || item.sharedAmount === undefined) {
          // sharedAmountOver = true
          item.sharedAmountOver = 0
        }
      })
      // if (sharedAmountOver) {
      //   this.$message.warning('分摊金额为空，请到供应商台账维护！')
      //   return
      // }
      if (tableDataMust) {
        this.$message.warning('请检查表格数据是否为空！')
        return
      }
      let allMoneyTxt = ""
      let oldTableData = JSON.parse(JSON.stringify(this.oldTableData))
      oldTableData.forEach(item => {
        item.mainBodyName = this.formVal.mainBodyName
        item.mainBodyId = this.formVal.mainBodyId
        item.sharedProductCode = this.formVal.sharedProductCode
        item.sharedProductName = this.formVal.sharedProductName
        item.businessTime = this.formVal.businessTime;
        let typeObj = this.tableData.filter(data => data.dataType === item.dataType);
        item.money = typeObj[0].money
        const supplierList = typeObj.map(typeObjItem => ({
          supplierLedgerId: typeObjItem.supplierLedgerId,
          supplierId: typeObjItem.supplierId,
          supplierName: typeObjItem.supplierName,
          mainSupplierCode: typeObjItem.mainSupplierCode,
          mainSupplierName: typeObjItem.mainSupplierName,
          costShareDepartment: typeObjItem.costShareDepartment,
          costShareDepartmentCode: typeObjItem.costShareDepartmentCode,
          businessSmallType: typeObjItem.businessSmallType,
          sharedAmount: typeObjItem.sharedAmount || 0,
        }));
        const supplierOrderList = typeObj.map(typeObjItem => ({
          amount: typeObjItem.sharedAmount || 0,
          customer: "",
          resarchProject: "",
          operationSubTypeId: typeObjItem.operationSubTypeId,
          venderCode: typeObjItem.mainSupplierCode,
          expenseDeptId: typeObjItem.costShareDepartmentCode,
        }));
        // //计算总金额
        // const totalSharedAmount = typeObj.reduce((sum, item) => {
        //   // 确保 sharedAmount 是数字，避免异常
        //   const amount = Number(item.sharedAmount) || 0;
        //   return this.decimal.add(Number(sum), Number(amount));
        // }, 0);
        // if(totalSharedAmount != item.money){
        //   allMoneyTxt = `${item.businessType}总金额${item.money}与分摊金额之和${totalSharedAmount}不相同,请调整之后再保存!`
        // }
        item.supplierList = supplierList
        item.attachment = JSON.stringify(typeObj[0].files)
        item.files = typeObj[0].files
        item.operationTypeCode = typeObj[0].operationTypeCode
        item.order = {
          icpsDataUrl: `https://lvshe.huashijc.com/#/purchaseSaleStoreDetail_HX?code=${item.code}`,
          boeAbstract: typeObj[0].resion,//事由
          postId: this.formVal.postId,//岗位
          project: this.formVal.sharedProductCode,//项目编码
          leCode: this.formVal.leCode,//核算主体
          employeeCode: this.formVal.employeeCode,//申请人
          operationTypeCode: item.operationTypeCode,//业务大类
          paperAccessories: this.formVal.paperAttachments, // 纸质附件是或否Y/N
          detailedinfomationarea: supplierOrderList,
          zfsAttachment: item.files
        }
      })
      if (allMoneyTxt) {
        this.$message.warning(allMoneyTxt)
        return
      }
      //shareStatus 状态为1和3的不推送
      const filteredData = oldTableData.filter(item => item.shareStatus !== 1 && item.shareStatus !== 3);
      const imgParams = filteredData.map(typeObjItem => ({
        dataType: typeObjItem.dataType,
        mainBodyId: typeObjItem.mainBodyId,
        businessTime: typeObjItem.businessTime,
        supplierList: typeObjItem.money == 0 ? [] : typeObjItem.supplierList,
      }));
      this.formVal['detailList'] = filteredData
      this.isSave = true
      querySupplier(imgParams).then(imgRes => {
        if (imgRes.code == 1001 && imgRes.data) {

          this.fetchAllDataAndGenerateImg(imgRes.data)
        } else {
          this.isSave = false
        }
      }).catch(() => {
        this.isSave = false
      })

    }, 500),
    async fetchAllDataAndGenerateImg(imgData) {
      console.log(imgData)
      for (let engIndex = 0; engIndex < imgData.length; engIndex++) {
        console.log('------for-----')
        this.supplierTableImgData = imgData[engIndex].amountShares,
          this.supplierTableImgType = imgData[engIndex].dataType
        // 等待 generateImg 完成后再继续下一次循环
        await this.generateImg(engIndex);
      }
      console.log('------------截图完成------------')
      console.log(this.formVal)
      this.formVal.detailList.forEach(item => {
        item.order.zfsAttachment = item.files
        item.attachment = JSON.stringify(item.files)
      })
      saveBusinessSingle(this.formVal).then((res) => {
        if (res.code == 1001) {
          this.$message.success(res.codeMsg)
          this.resetForm();
          this.$router.push({ name: 'accountingSheet', query: { mainBodyId: this.formVal.mainBodyId, businessTime: this.formVal.businessTime } })
        }
        this.isSave = false
      }).catch(() => {
        this.isSave = false
      });
    },
    async generateImg() {
      await this.$nextTick();

      return new Promise((resolve, reject) => {
        const table = this.$refs[`supplierTable`].$el;
        console.log(table)
        html2canvas(table).then(canvas => {
          canvas.toBlob(blob => {
            if (!blob) {
              return reject(new Error('canvas.toBlob 返回了 null'));
            }
            const file = new File([blob], "截图.jpg", { type: "image/jpg" });
            const params = new FormData();
            console.log('上传文件大小:', file.size, '类型:', file.type);
            params.append("file", file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                res.data.fileUrl = 'https://lvshe.huashijc.com/file/' + res.data.fileUrl;
                console.log(res.data.fileUrl)
                let obj = {
                  name: this.supplierTableImgType == 1 ? "原材料耗用.jpg " : this.supplierTableImgType == 2 ? "委托材料出库.jpg" : "委托材料耗用.jpg",
                  url: res.data.fileUrl
                }
                this.formVal.detailList.forEach(item => {
                  if (item.dataType == this.supplierTableImgType) {
                    item.files.push(obj)
                  }
                })
                resolve(res.data);
              } else {
                this.saveLoading = false
                this.isSave = false
                reject(new Error('上传失败，code=' + res.code));
              }
            }).catch(err => {
              this.saveLoading = false
              this.isSave = false
              reject(err)
            }

            );
          });
        }).catch(err => {
          this.$emit("mainLoadingClose")
          reject(err)
        }
        );
      });
    },
    updateGXCostState() {
      let param = {
        endTime: this.params.endTime,
        startTime: this.params.startTime,
        lisiTime: this.params.lisiTime,
        settleMonth: this.params.settleMonth,
        companyId: this.params.secondId,
        checkStatus: 0,
        gxStatus: 0
      }
      updateGXCostState(param).then(res => {
        if (res.code == 1001) {
          let dataContent = {
            params: param,
            settlementStartTime: param.startTime,
            settlementEndTime: param.endTime,
            periodSettlement: [param.startTime, param.endTime]
          }
          const query = {
            type: 1,
            taskName: "业务记账单审批表",
            taskStatus: 0,
            taskType: 1,
            dataContent: JSON.stringify(dataContent)
          };
          this.$router.push({ name: 'submitBusinessBilling', query: query })
        }
      }).catch(() => {
        // this.$message.warning(r) 
      })
    },
    sizeChange(value) {
      this.tableParams.pageSize = value;
      this.initData();
    },
    arraySpanMethod({ row, rowIndex, columnIndex }) {
      // 需要合并的列索引（第1、5、6列）
      const mergeCols = [0, 5, 6, 7, 8];
      if (!mergeCols.includes(columnIndex)) {
        return [1, 1]; // 不合并
      }

      // 只有当列是需要合并的列时才处理
      const data = this.tableData;
      const currentDataType = row.dataType;

      // 如果是第一行，计算连续相同 dataType 的行数
      if (rowIndex === 0) {
        let rowspan = 1;
        for (let i = 1; i < data.length; i++) {
          if (data[i].dataType === currentDataType) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      } else {
        // 非第一行，判断上一行 dataType 是否相同
        if (data[rowIndex - 1].dataType === currentDataType) {
          // 与上一行相同，隐藏当前单元格
          return [0, 0];
        } else {
          // 不同，计算连续相同 dataType 的行数
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].dataType === currentDataType) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.addClass {
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: #00b85c !important;
}
</style>